<template>
  <section>
    <div id="gallery" class="pd70 lazy">
      <div class="wrapper">
        <h2 class="block_title">{{ h2 }}</h2>

        <div class="gallery-iamge" v-if="data?.image?.length">
          <UiAnim
            type="t-30"
            v-for="(a, i) in data.image"
            :key="i"
            class="gallery-item"
          >
            <UiLazyImg
              :wrapAttr="{
                href: `/upload/image/${a}/big.jpg`,
              }"
              tag="a"
              :src="`/upload/image/${a}/gallery.jpg`"
              @click.prevent="showGallery(i)"
            />
          </UiAnim>
          <span class="clr"></span>
        </div>

        <div class="gallery-video" v-if="data?.video?.length">
          <UiAnim
            type="t-30"
            v-for="(a, i) in data.video"
            :key="i"
            class="gallery-item"
          >
            <UiLazyImg
              :wrapAttr="{
                href: `https://www.youtube.com/live/${a}`,
                class: 'video-box',
              }"
              tag="a"
              :src="`https://img.youtube.com/vi/${a}/mqdefault.jpg`"
              @click.prevent="showYoutube(a)"
            />
          </UiAnim>
          <span class="clr"></span>
        </div>
      </div>
    </div>
  </section>
  <ModalYoutube :src="youtube" v-if="youtube" @closed="youtube = null" />
  <ModalSwiperGallery
    :data="galData"
    :current="current"
    v-if="current >= 0"
    @closed="current = -1"
  />
</template>

<script setup>
const { isModal, setData, mYoutube } = useModal();
const youtube = ref();
const current = ref(-1);
const galData = ref();
const props = defineProps(["data", "h2", "name"]);
if (props.data?.image) {
  const images = [];
  props.data.image.forEach((a) => {
    images.push(`/upload/image/${a}/big.jpg`);
  });
  galData.value = images;
}
const showGallery = (i) => {
  if (props.name && !isModal)
    return setData(props.name, { images: galData.value, index: i });
  current.value = i;
};
const showYoutube = (src) => {
  if (!isModal) return mYoutube(src);
  youtube.value = src;
};
</script>
